import { observer } from "mobx-react";
import { h } from "preact";
import { t, Tracking, translate, } from "restaumatic-client";
import { hideModal } from "../utils/Modals";
import Alert from "./Alert";
import CrossSellingList from "./CrossSellingList";
import PreactModal, { ModalHeader, ModalFooter } from "./PreactModal";
import OrderButtonPrice from "./OrderButtonPrice";
import OrderButtonLabel from "./OrderButtonLabel";
export const CROSS_SELLING_ADD_TO_CART_BOTTOM_SHEET_ID = "cross-selling-add-to-cart-bottom-sheet";
function CrossSellingAddToCartBottomSheet(props) {
    const { crossSellingBottomSheet } = props;
    const { crossSellingItems, buttonText } = crossSellingBottomSheet;
    const isHeaderVisible = Skubacz.Device.screen.isSmallUp();
    const handleContinueClick = () => {
        var _a, _b;
        void hideModal(CROSS_SELLING_ADD_TO_CART_BOTTOM_SHEET_ID).then(() => {
            crossSellingBottomSheet.addToCart();
        });
        Tracking.trackEvent({
            tag: "CrossSellingAddToCartBottomSheetCtaClicked",
            contents: {
                price: (_b = (_a = crossSellingBottomSheet.trackingPrice) === null || _a === void 0 ? void 0 : _a.asNumber) !== null && _b !== void 0 ? _b : -1,
            },
        });
    };
    return (h(PreactModal, { id: CROSS_SELLING_ADD_TO_CART_BOTTOM_SHEET_ID, modalClass: "modal-dialog--bottomsheet", onShow: () => crossSellingBottomSheet.cleanSelectedItems(), dataFieldId: "crossSellingAddToCartBottomSheet" },
        isHeaderVisible && h(ModalHeader, { title: "" }),
        h("div", { class: "modal-body u-pt4" },
            h(Alert, { type: "success", icon: "ok-circled", message: translate(t.client.cross_selling_add_to_cart_bottomsheet.added_to_cart), extraClasses: "u-mb1" }),
            crossSellingItems.length > 0 && (h(CrossSellingList, { fieldId: "crossSellingAddToCartBottomSheet.list", title: translate(t.crossup.title), items: crossSellingItems }))),
        h(ModalFooter, null,
            h("button", { type: "button", class: "btn btn-primary btn-block", "data-field-id": "crossSellingAddToCartBottomSheet.continue", onClick: handleContinueClick },
                h(OrderButtonLabel, { text: buttonText.label }),
                h(OrderButtonPrice, { price: buttonText.price })))));
}
export default observer(CrossSellingAddToCartBottomSheet);
